import { AddIcon, EditIcon, SearchIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Heading,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Spacer,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tooltip,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { franchiseMapIndex } from "../../../core/constants";
import { getAdminComics } from "../../../services/adminApi";
import Spinner from "../../../shared/components/Spinner";
import { Card } from "../../auth/components/Login/Card";

const ComicsList = ({ embedded = false }) => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue("gray.50", "inherit");
  const [sort, setSort] = useState({ column: "id", direction: "desc" });
  const [filterBy, setFilterBy] = useState({
    franchise: "",
    searchTerm: "",
  });

  const { data, isSuccess, isLoading, isError } = useQuery(
    [
      "comics",
      filterBy.franchise,
      filterBy.searchTerm,
      sort.column,
      sort.direction,
    ],
    () =>
      getAdminComics(
        filterBy.franchise,
        filterBy.searchTerm,
        sort.column,
        sort.direction
      )
  );

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleFilter("searchTerm", event.target.value);
    }
  };

  const handleFilter = (filterType, value) => {
    setFilterBy((prevFilterBy) => ({
      ...prevFilterBy,
      [filterType]: value,
    }));
  };

  const handleSort = (column) => {
    if (sort.column === column) {
      setSort((prevSort) => ({
        column,
        direction: prevSort.direction === "asc" ? "desc" : "asc",
      }));
    } else {
      setSort({ column, direction: "asc" });
    }
  };

  const onEditInfo = (comicId) => {
    navigate(`/comics/${comicId}/edit`);
  };

  const content = (
    <>
      <Flex mb={4}>
        <Center minW={100}>
          <p>Filter by</p>
        </Center>
        <Select
          onChange={(e) => handleFilter("franchise", e.target.value)}
          value={filterBy.franchise}
          mr={4}
        >
          <option value="">All franchises</option>
          {Object.keys(franchiseMapIndex).map((franchise, index) => (
            <option value={franchise} key={franchise}>
              {franchiseMapIndex[franchise]}
            </option>
          ))}
        </Select>
        <InputGroup>
          <InputLeftElement
            pointerEvents="none"
            children={<SearchIcon color="gray.300" />}
          />
          <Input
            type="search"
            name="searchTerm"
            onBlur={(e) => handleFilter("searchTerm", e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Search by title"
          />
        </InputGroup>
      </Flex>
      <Divider />
      {isError && <p>Error.</p>}
      {isLoading && <Spinner />}
      {isSuccess && !isLoading && (
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th onClick={() => handleSort("id")}>
                ID{" "}
                {sort.column === "id" && (
                  <span>{sort.direction === "asc" ? " ▼" : " ▲"}</span>
                )}
              </Th>
              <Th onClick={() => handleSort("title")}>
                Title{" "}
                {sort.column === "title" && (
                  <span>{sort.direction === "asc" ? " ▼" : " ▲"}</span>
                )}
              </Th>
              <Th onClick={() => handleSort("franchise")}>
                Franchise{" "}
                {sort.column === "franchise" && (
                  <span>{sort.direction === "asc" ? " ▼" : " ▲"}</span>
                )}
              </Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.data.map((comic) => (
              <Tr key={comic.id}>
                <Td>{comic.id}</Td>
                <Td>{comic.title}</Td>
                <Td>{franchiseMapIndex[comic.franchise]}</Td>
                <Td>
                  <Flex>
                    <Spacer />
                    <Tooltip hasArrow label="Edit comic">
                      <IconButton
                        aria-label="Edit comic info"
                        icon={<EditIcon />}
                        onClick={() => onEditInfo(comic.id)}
                      />
                    </Tooltip>
                    {/* <Tooltip hasArrow label="Delete order">
                      <IconButton
                        aria-label="Delete Order"
                        icon={<DeleteIcon />}
                        onClick={() => onDeleteOrder(order.id)}
                      />
                    </Tooltip> */}
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </>
  );

  if (embedded) {
    return content;
  }

  return (
    <Box bg={bgColor} minH="100vh" py="12" px={{ base: "4", lg: "8" }}>
      <Box maxW="xxl" mx="auto">
        <Card>
          <Center>
            <Heading as="h2" my="6">
              Comics
            </Heading>
            <Button
              onClick={() => navigate("/comics/new")}
              ml="auto"
              leftIcon={<AddIcon />}
            >
              Add a new comic
            </Button>
          </Center>
          {content}
        </Card>
      </Box>
    </Box>
  );
};

export default ComicsList;
